export const COLLAPSED_COMMENT_POPUP_PREFIX = 'collapsed-comment-';
export const getCollapsedCommentPopupId = (elementId: string) => `${COLLAPSED_COMMENT_POPUP_PREFIX}${elementId}`;
